import IncotermsComplements from ".";

export const incotermsComplementRoutes = [
  {
    path: "/incotermsComplement",
    element: <IncotermsComplements />,
  },
];
